import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { Paper } from '@openx/components-core/lib/Paper/Paper';
import type { ReactNode } from 'react';

interface Props {
  actionCancel?: ReactNode;
  actionConfirm?: ReactNode;
  checkbox?: ReactNode;
  content?: ReactNode;
  navbar?: ReactNode;
}

export const Layout = ({ actionCancel, actionConfirm, checkbox, content, navbar }: Props) => {
  const actionsVisible = actionCancel || actionConfirm;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
      {navbar}
      <Box sx={{ flexGrow: 1, minHeight: 0, overflowY: 'auto' }} data-test="terms-scroll-container">
        <Grid
          container
          sx={{
            justifyContent: 'center',
            mt: 3,
            mb: 3,
          }}
        >
          <Grid size={6}>
            <Paper>
              {({ ActionsSection }) => (
                <>
                  {content}
                  {checkbox}
                  {actionsVisible && (
                    <ActionsSection>
                      <Grid
                        container
                        spacing={2}
                        sx={{
                          justifyContent: 'flex-end',
                          alignItems: 'center',
                        }}
                      >
                        <Grid>{actionCancel}</Grid>
                        <Grid>{actionConfirm}</Grid>
                      </Grid>
                    </ActionsSection>
                  )}
                </>
              )}
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};
